module.exports = __webpack_public_path__ + "img/i_icon01.3ba42281.png";